var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsupportedLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 78,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 220 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #b5b5b5;\n      }\n\n      .st2 {\n        fill: #c4c4c4;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 220,
    height: 78
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 220,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: -263.4,
    y: -57.9,
    width: 560,
    height: 13,
    transform: "translate(41.2 -3.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -189.9,
    y: 15.6,
    width: 560,
    height: 13,
    transform: "translate(10.8 70.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -226.6,
    y: -21.1,
    width: 560,
    height: 13,
    transform: "translate(26 33.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -153.1,
    y: 52.4,
    width: 560,
    height: 13,
    transform: "translate(-4.5 107) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -245,
    y: -39.5,
    width: 560,
    height: 13,
    transform: "translate(33.6 15.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -171.5,
    y: 34,
    width: 560,
    height: 13,
    transform: "translate(3.1 88.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -208.3,
    y: -2.8,
    width: 560,
    height: 13,
    transform: "translate(18.4 51.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -134.7,
    y: 70.8,
    width: 560,
    height: 13,
    transform: "translate(-12.1 125.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -116.3,
    y: 89.2,
    width: 560,
    height: 13,
    transform: "translate(-19.7 143.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: -98,
    y: 107.5,
    width: 560,
    height: 13,
    transform: "translate(-27.3 162.1) rotate(-45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedLight);
export default __webpack_public_path__ + "static/media/unsupported-light.c3da3142f9b109bc937be45f31f9039c.svg";
export { ForwardRef as ReactComponent };